import { Grid, Typography, Box } from "@mui/material";
import {
    DossierDetailType,
    EstablishmentCategory,
    GroupedDossierList,
} from "../../types";
import OverViewDossierWrapper from "./Dossier/OverViews/OverViewDossierWrapper";

type DossiersListProps = {
    groupedDossiersByRefs: GroupedDossierList;
    instructorList: any[];
    toBulkAssignedDossier: Function;
    downloadCertificate: Function;
    regionList: EstablishmentCategory[];
};

export default function DossiersList({
    groupedDossiersByRefs,
    instructorList,
    toBulkAssignedDossier,
    downloadCertificate,
    regionList,
}: DossiersListProps) {
    return (
        <Grid container spacing={2}>
            {Object.values(groupedDossiersByRefs).map(
                (dossiersListOfRef: DossierDetailType[], index: number) => {
                    const { referenciel } = dossiersListOfRef[0];
                    return (
                        <Grid item xs={12} md={6} key={index}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "1rem",
                                    flexDirection: "column",
                                    flexShrink: 0,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#023",
                                        fontFamily: "Roboto",
                                        fontSize: "1.125rem",
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        lineHeight: "normal",
                                    }}
                                >
                                    {referenciel ? referenciel.name : ""}
                                </Typography>
                                {dossiersListOfRef.map(
                                    (dossier: DossierDetailType) => {
                                        return (
                                            <Box
                                                key={dossier.id}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                    gap: "1rem",
                                                    flexDirection: "column",
                                                    flexShrink: 0,
                                                    width: "100%",
                                                }}
                                            >
                                                <OverViewDossierWrapper
                                                    dossierDetail={dossier}
                                                    instructorList={
                                                        instructorList
                                                    }
                                                    toBulkAssignedDossier={
                                                        toBulkAssignedDossier
                                                    }
                                                    downloadCertificate={
                                                        downloadCertificate
                                                    }
                                                    regionList={regionList}
                                                />
                                            </Box>
                                        );
                                    }
                                )}
                            </Box>
                        </Grid>
                    );
                }
            )}
        </Grid>
    );
}
